"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapableHandle = void 0;
const lru_cache_1 = __importDefault(require("lru-cache"));
const RegionHandle_1 = require("./RegionHandle");
const AggregatedRegionPartialCapacityPeriod_1 = require("./AggregatedRegionPartialCapacityPeriod");
const RegionPartialCapacityPeriod_1 = require("./RegionPartialCapacityPeriod");
class CapableHandle {
    constructor(capable) {
        this.monthlyCapacityCache = new lru_cache_1.default(18);
        Object.assign(this, capable);
    }
    getOffboardDate() {
        return this.offboardDate &&
            !isNaN(this.offboardDate.year) &&
            !isNaN(this.offboardDate.month) &&
            !isNaN(this.offboardDate.day)
            ? new Date(this.offboardDate.year, this.offboardDate.month, this.offboardDate.day)
            : undefined;
    }
    getCapacities(year, month) {
        const offboardDate = this.getOffboardDate();
        const from = new Date(year, month, 1);
        const endOfMonth = new Date(year, month + 1, 1);
        const to = offboardDate
            ? new Date(Math.min(endOfMonth.getTime(), offboardDate.getTime()))
            : endOfMonth;
        if (to.getTime() < from.getTime()) {
            return [];
        }
        const filtered = (this.utilization || [])
            .concat([])
            .sort((a, b) => new Date(a.year || 0, a.month || 0, a.day || 1).getTime() -
            new Date(b.year || 0, b.month || 0, b.day || 1).getTime())
            .reduce((all, newUtilization) => {
            const newTime = new Date(newUtilization.year || from.getFullYear(), newUtilization.month || from.getMonth(), newUtilization.day || 1).getTime();
            if (newTime >= to.getTime()) {
            }
            else if (newTime > from.getTime() && newTime < to.getTime()) {
                all.push(newUtilization);
            }
            else {
                if (all.length > 0) {
                    all[0] = newUtilization;
                }
                else {
                    all.push(newUtilization);
                }
            }
            return all;
        }, []);
        return filtered;
    }
    getCapacityPeriods(year, month, region) {
        const end = new Date(year, month + 1, 0).getDate();
        const capacities = this.getCapacities(year, month);
        return capacities.map((capacity, index, all) => {
            const from = capacity.day || 1;
            const to = index < all.length - 1 ? all[index + 1].day : end;
            const period = region.getUtilizationPeriod(new Date(year, month, from), new Date(year, month, to));
            const holidays = new Set((period.holidays || []).map((h) => h.day));
            const daysOff = this.getTimeOff(year, month)
                .filter((day) => {
                const dayOfWeek = new Date(year, month, day).getDay();
                return !holidays.has(day) && dayOfWeek !== 0 && dayOfWeek !== 6;
            })
                .sort();
            return new RegionPartialCapacityPeriod_1.RegionPartialCapacityPeriod(capacity, period, daysOff.filter((day) => day >= from && day < to));
        });
    }
    getCapacityPeriods1850(year, month) {
        const capacities = this.getCapacities(year, month);
        return capacities.map((capacity, index, all) => {
            return new RegionPartialCapacityPeriod_1.PartialCapacityPeriod1850(capacity);
        });
    }
    getCapacity(year, month, region = RegionHandle_1.DEFAULT_REGION) {
        const key = `${year}-${month}`;
        if (!this.monthlyCapacityCache.has(key)) {
            const result = this.getCapacityPeriods(year, month, region);
            this.monthlyCapacityCache.set(`${year}-${month}`, new AggregatedRegionPartialCapacityPeriod_1.AggregatedRegionPartialCapacity(result));
        }
        return this.monthlyCapacityCache.get(key);
    }
    getCapacity1850(year, month) {
        const key = `${year}-${month}-1850`;
        if (!this.monthlyCapacityCache.has(key)) {
            const result = this.getCapacityPeriods1850(year, month);
            this.monthlyCapacityCache.set(`${year}-${month}-1850`, new AggregatedRegionPartialCapacityPeriod_1.AggregatedPartialCapacity1850(result));
        }
        return this.monthlyCapacityCache.get(key);
    }
    getTimeOff(year, month) {
        const yearMonth = `${year}-${month}`;
        const staffingCalendarTimeOff = this.staffingCalendarTimeOff || {};
        const days = staffingCalendarTimeOff[yearMonth] || [];
        return days;
    }
    isOffboarded(now = new Date()) {
        const offboarding = this.getOffboardDate();
        return !!offboarding && offboarding.getTime() <= now.getTime();
    }
}
exports.CapableHandle = CapableHandle;
//# sourceMappingURL=CapableHandle.js.map